import { CognitoUserPool } from 'amazon-cognito-identity-js'

 
  const UserPoolId = process.env.UserPoolId || "us-west-2_1wrdipDKE"; 
const ClientId = process.env.ClientId || "6692ul8m88amkm4avot1k7gq8m"; 
  const poolData={
    UserPoolId:UserPoolId,
    ClientId:ClientId
  }
  export default new CognitoUserPool(poolData);
